// extracted by mini-css-extract-plugin
module.exports = {"ingelogdeGebruikerContainer":"gebruiker-dropdown_ingelogdeGebruikerContainer__NhVjV","menuBtn":"gebruiker-dropdown_menuBtn__SPBWZ"};